var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 6.5,
    fill: "#FFA700",
    stroke: "#FFA700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.907 16.03a.667.667 0 01-.486-.214l-3.24-3.447a.667.667 0 11.973-.913l2.747 2.927 5.606-6.134a.667.667 0 11.987.894l-6.093 6.666a.667.667 0 01-.487.22h-.007z",
    fill: "#fff"
  })));
}

export default SvgLedCheck;